const RESOURCE_NAME = "entities/questionQuestionnaires";

export default {};
